import { render, staticRenderFns } from "./ShowQuestion.vue?vue&type=template&id=780a0644"
import script from "./ShowQuestion.vue?vue&type=script&lang=js"
export * from "./ShowQuestion.vue?vue&type=script&lang=js"
import style0 from "./ShowQuestion.vue?vue&type=style&index=0&id=780a0644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports